import React from 'react';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/user';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { Card, CardActions, CardHeader, CardTitle, CardText } from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableBody,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import { DOWNLOAD_FILE_SUCCESS, CHANGE_PASSWORD_SUCCESS } from '../../constants';

function mapStateToProps(state) {
    return {
        data: state.user,
        token: state.auth.token,
        userId: state.auth.userId,
        url: state.user.url,
        isDownloading: state.user.isDownloading,
        action: state.user.action,
        statusText: state.user.statusText,
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

@connect(mapStateToProps, mapDispatchToProps)
export default class CustomerView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDownloading: false,
            old_password: null,
            password: null,
            password_error_text: null,
            old_password_error_text: null,
            show_success_password: false,
        };
    }

    componentDidMount() {
        this.fetchUser(this.props.userId);
        this.fetchFiles(this.props.userId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.action == DOWNLOAD_FILE_SUCCESS) {

            setTimeout(() => {
                window.location.href = this.props.url;
            }, 100);
        }
        if (nextProps.action === CHANGE_PASSWORD_SUCCESS) {
            this.handlePasswordFormClose();
            this.setState({ show_success_password: true });
        }
    }

    isPassDisabled() {
        let password_is_valid = false;
        let old_password_is_valid = false;

        //password chehck
        if (this.state.password === '' || !this.state.password) {
            this.setState({
                password_error_text: null,
            });
        } else if (this.state.password.length >= 6) {
            password_is_valid = true;
            this.setState({
                password_error_text: null,
            });
        } else {
            this.setState({
                password_error_text: 'Your password must be at least 6 characters',
            });
        }

        //old password chehck
        if (this.state.old_password === '' || !this.state.old_password) {
            this.setState({
                old_password_error_text: null,
            });
        } else if (this.state.old_password.length >= 6) {
            old_password_is_valid = true;
            this.setState({
                old_password_error_text: null,
            });
        } else {
            this.setState({
                old_password_error_text: 'Your password must be filled',
            });
        }

        if (password_is_valid && old_password_is_valid) {
            this.setState({
                disabledPass: false,
            });
        }
    }

    fetchUser(id) {
        const token = this.props.token;
        this.props.viewUser(id, token);
    }

    fetchFiles(id) {
        const token = this.props.token;
        this.props.viewUserFiles(id, token);
    }

    onDrop = (files) => {
        const token = this.props.token;
        const id = this.props.location.state.userId;
        this.props.uploadUserFile(id, files[0], token);
    }

    downloadFile(e, id) {
        e.preventDefault();
        ReactGA.event({
            category: 'Downloads',
            action: 'File',
            value: id
        });
        this.props.downloadFile(id, this.props.token)
    }

    changePassValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state, () => {
            this.isPassDisabled();
        });
    }

    handlePasswordFormOpen = () => {
        this.setState({ passwordFormStateOpen: true });
    };

    handlePasswordFormClose = () => {
        this.setState({ passwordFormStateOpen: false });
    };

    updatePass(e) {
        e.preventDefault();
        ReactGA.event({
            category: 'Users',
            action: 'ChangePassword'
        });
        this.props.changePass(this.props.data.user.id, this.state.old_password, this.state.password, this.props.token)
    }

    render() {
        const actionsPass = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handlePasswordFormClose}
            />,
            <FlatButton
                label="Change"
                primary={true}
                disabled={this.state.disabled}
                onClick={(e) => this.updatePass(e)}
            />,
        ];
        return (
            <div className="container">
                {this.props.data.user ?
                    <div className="row">
                        <Snackbar
                            open={this.state.show_success_password || false}
                            message="Password updated successfully."
                            autoHideDuration={4000}
                        />
                        <Card>
                            <CardHeader
                                title={'' + this.props.data.user.first_name + ' ' + this.props.data.user.last_name}
                                subtitle={this.props.data.user.username}
                                avatar={<Avatar>{this.props.data.user.first_name.charAt(0)}</Avatar>}                                
                            />
                            <CardText>
                                <div className="row">
                                    <div className="col-md-4">
                                        <RaisedButton label="Change Password" primary={true} onClick={(e) => this.handlePasswordFormOpen()} />
                                    </div>
                                </div>
                            </CardText>
                            <CardTitle title="Files" />
                            <CardText>
                                <Table>
                                    <TableHeader displaySelectAll={false}
                                        adjustForCheckbox={false}>
                                        <TableRow>
                                            <TableHeaderColumn>File Name</TableHeaderColumn>
                                            <TableHeaderColumn></TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody displayRowCheckbox={false}>
                                        {this.props.data.files && this.props.data.files.map(row => {
                                            return (
                                                <TableRow key={row.id}>
                                                    <TableRowColumn>{row.name}</TableRowColumn>
                                                    <TableRowColumn>
                                                        <FlatButton label="Download" onClick={(e) => this.downloadFile(e, row.id)} />
                                                    </TableRowColumn>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </CardText>
                            <CardActions>
                            </CardActions>
                        </Card>
                        <Dialog
                            title="Change Password"
                            actions={actionsPass}
                            modal={true}
                            open={this.state.passwordFormStateOpen || false}
                        >
                            <div className="col-md-6 col-md-offset-3">
                                {
                                    this.props.statusText &&
                                    <div className="alert alert-info">
                                        {this.props.statusText}
                                    </div>
                                }
                                <form role="form">
                                    <div className="text-center">
                                        <div className="col-md-12">
                                            <TextField
                                                hintText="Old Password"
                                                floatingLabelText="Old Password"
                                                type="password"
                                                errorText={this.state.old_password_error_text}
                                                onChange={(e) => this.changePassValue(e, 'old_password')}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <TextField
                                                hintText="New Password"
                                                floatingLabelText="New Password"
                                                type="password"
                                                errorText={this.state.password_error_text}
                                                onChange={(e) => this.changePassValue(e, 'password')}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Dialog>
                    </div>
                    : ''}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Customer/CustomerView.js